import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { user } from '@app/_shared/_models/user';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
import { ForumEvenementService } from '@app/_shared/_services/forum/evenement.service';
import { ForumInscriptionService } from '@app/_shared/_services/forum/inscription.service';
import * as _ from "underscore"
declare var _smartsupp;

@Component({
  selector: 'app-cllajinscription',
  templateUrl: './cllajinscription.component.html',
  styleUrls: ['./cllajinscription.component.scss']
})
export class CllajinscriptionComponent implements OnInit {

  @Output() onClose:EventEmitter<any> = new EventEmitter<any>();

  subscriptions: any = [];
  currentUser: user;
  finalForm;
  saving:boolean = false;
  canContinue = false;
  constructor(
    public authenticationService: AuthenticationService,public inscriptionService:ForumInscriptionService,private evenementService:ForumEvenementService) {
    this.subscriptions.push(
      this.authenticationService.currentUser.subscribe(
        (x) => {
          this.currentUser  = x;
          if(this.currentUser)
          this.inscriptionService.form.idUser = this.currentUser.id
        }
      )
    );
  }

    ngOnDestroy() {
      _.each(this.subscriptions, (sub) => sub.unsubscribe());
    }

  ngOnInit(): void {

    if(this.inscriptionService.form.step == 4){
      this.inscriptionService.clearFormSessionStorage()
    }
    this.inscriptionService.refreshFormSessionStorage();
    this.evenementService.getItems({where:{active:true}}).subscribe(res=>{
      if(res.items?.length){
        this.evenementService.setSelectedItem(res.items[0])
        this.inscriptionService.form.idEvenement =res.items[0].id
        this.canContinue = true;
      }
    })
    if(this.currentUser)
    this.inscriptionService.form.idUser = this.currentUser.id

    if(!this.inscriptionService.form.step)
    this.inscriptionService.form.step = 1
  }

  goPart2(form){
    this.inscriptionService.form.step = 2;
}
goPart3(form){
    this.inscriptionService.form.step = 3;
}
  prevStep(){
    if(this.inscriptionService.form.step>1)
    this.inscriptionService.form.step = this.inscriptionService.form.step--;
  }
  goPart1(){
    this.inscriptionService.form.step = 1;
  }

  goPart4(){
    // save
    if(!this.saving){
      this.saving = true;
    this.save().then(()=>{
      this.inscriptionService.form.step = 4;
      this.saving = false;
    }).catch(err =>{
      this.saving = false;
    })
  }
  }
  save(){
    return new Promise<void>((resolve, reject) => {

        this.inscriptionService.saveInscription().subscribe(res=>{
          console.log('inscription ok', res)
          this.finalForm = _.clone(this.inscriptionService.form)
          this.inscriptionService.clearFormSessionStorage()
          resolve(res)
        },err=>reject(err))
    })
  }
  close(){
    this.onClose.emit()
  }

  hasOnlySP(){
    let hasSP = _.find(this.finalForm.salons.selectedItems, item => item.type == "petitsalon_offres" );
    let hasS =  _.find(this.finalForm.salons.selectedItems, item => item.type == "petitsalon_rdv" );
    let hasD = _.find(this.finalForm.salons.selectedItems, item => item.type == "petitsalon_delivrance" );
    return hasSP  && !hasD
  }
  hasOnlyD(){
    let hasSP = _.find(this.finalForm.salons.selectedItems, item => item.type == "petitsalon_offres" );
    let hasS =  _.find(this.finalForm.salons.selectedItems, item => item.type == "petitsalon_rdv" );
    let hasD = _.find(this.finalForm.salons.selectedItems, item => item.type == "petitsalon_delivrance" );
    return hasD && !hasSP
  }
  hasOnlySPD(){
    let hasSP = _.find(this.finalForm.salons.selectedItems, item => item.type == "petitsalon_offres" );
    let hasS =  _.find(this.finalForm.salons.selectedItems, item => item.type == "petitsalon_rdv" );
    let hasD = _.find(this.finalForm.salons.selectedItems, item => item.type == "petitsalon_delivrance" );
    return hasD && hasSP
  }

}
